import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

export const reviewMindly = async (rate?: number, comment?: string) => {
  const response = await HttpHandler({
    method: 'POST',
    url: `${environment.CLIENT_MINDLY_REVIEWS_URL}/mindly-review`,
    data: {
      rate,
      comment,
    },
  });

  return response.data;
};

export const loadMindlyReview = async () => {
  const response = await HttpHandler({
    method: 'GET',
    url: `${environment.CLIENT_MINDLY_REVIEWS_URL}/mindly-review`,
  });

  return response.data;
};
